// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ポップアップ全体を覆うオーバーレイ */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* ポップアップのコンテナ */
.popupContainer {
  position: relative;
}

/* ポップアップ本体 */
.popup {
  width: 50vh;
  height: 50vh;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeInUp 0.5s ease-in-out;
}

.closeButton {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 3.5rem; /* ボタンを大きく */
  background-color: rgba(0, 0, 0, 0.2); /* 半透明の背景 */
  border: none;
  color: #fff; /* ボタンの色を白に */
  cursor: pointer;
  padding: 0.5rem;
  z-index: 10000;
  width: 3.5rem; /* 正方形の幅 */
  height: 3.5rem; /* 正方形の高さ */
  display: flex; /* 中央揃えのための設定 */
  justify-content: center;
  align-items: center;
  border-radius: 5px; /* 若干の丸み */
}

/* 画像スタイル */
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ポップアップアニメーション */
@keyframes fadeInUp {
  from {
    transform: translateY(20%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.popup-animation {
  animation: fadeInUp 0.5s ease-in-out;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Popup.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB,EAAE,YAAY;EAC/B,oCAAoC,EAAE,WAAW;EACjD,YAAY;EACZ,WAAW,EAAE,aAAa;EAC1B,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa,EAAE,UAAU;EACzB,cAAc,EAAE,WAAW;EAC3B,aAAa,EAAE,eAAe;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB,EAAE,UAAU;AAChC;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* ポップアップ全体を覆うオーバーレイ */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n/* ポップアップのコンテナ */\n.popupContainer {\n  position: relative;\n}\n\n/* ポップアップ本体 */\n.popup {\n  width: 50vh;\n  height: 50vh;\n  background-color: #fff;\n  border-radius: 10px;\n  position: relative;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  animation: fadeInUp 0.5s ease-in-out;\n}\n\n.closeButton {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 3.5rem; /* ボタンを大きく */\n  background-color: rgba(0, 0, 0, 0.2); /* 半透明の背景 */\n  border: none;\n  color: #fff; /* ボタンの色を白に */\n  cursor: pointer;\n  padding: 0.5rem;\n  z-index: 10000;\n  width: 3.5rem; /* 正方形の幅 */\n  height: 3.5rem; /* 正方形の高さ */\n  display: flex; /* 中央揃えのための設定 */\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px; /* 若干の丸み */\n}\n\n/* 画像スタイル */\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* ポップアップアニメーション */\n@keyframes fadeInUp {\n  from {\n    transform: translateY(20%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.popup-animation {\n  animation: fadeInUp 0.5s ease-in-out;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
